// The menu a long press, a right-click, the menu key or a row's "more" button opens: a Sheet that
// lists RowActions. It is the tap-and-keyboard twin of every gesture shortcut.
import { Button } from "./controls";
import { Icon } from "./Icon";
import type { RowAction } from "./gestures/actions";
import { Sheet } from "./Sheet";

export interface ActionSheetProps {
  /** The menu's accessible name, usually the row's title. */
  label: string;
  actions: readonly RowAction[];
  onClose: () => void;
}

export function ActionSheet({ label, actions, onClose }: ActionSheetProps): React.JSX.Element {
  return (
    <Sheet label={label} onClose={onClose} testId="action-sheet">
      {actions.map((action) => (
        <Button
          key={action.id}
          tone={action.tone === "danger" ? "danger" : "secondary"}
          label={action.label}
          icon={action.icon === undefined ? undefined : <Icon name={action.icon} size={18} />}
          disabled={action.disabled === true}
          full
          onPress={() => {
            onClose();
            action.onSelect();
          }}
        />
      ))}
    </Sheet>
  );
}
